
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue } from "vue-property-decorator";
import { AiCostTracking } from "@/interfaces/AiCostTracking";

@Component
export default class AiUsage extends Vue {
  aiUsage: AiCostTracking[] = [];

  // $refs!: {};

  headers = [
    { text: "Datum", value: "date",sortable: true },
    { text: "Gesamtkosten", value: "totalCostInCents",sortable: true },
    { text: "Nutzungslimit", value: "usageLimitInEuro", sortable: true },
    { text: "Verbleibendes Guthaben", value: "remainingCreditBalanceInPercent", sortable: true },
    { text: "Details", value: "details", sortable: false },
  ];


  mounted() {
    this.updateAiUsage();
  }

  async updateAiUsage() {
    this.aiUsage = await rest.url("admin/getAiUsage").get();
  }
}
